const AlgorithmsTranslations = {
  header: "Алгоритмы"
}

export default AlgorithmsTranslations
